import { navigation } from "../../data/site";
import { useNavigationState } from "../../hooks/useNavigationState";
import { Link } from "react-router-dom";
import { ThemeToggle } from "../common/ThemeToggle";
export function Navigation() {
  const { open, setOpen, active, toggle, progress } = useNavigationState();

  return (
    <header className="site-header">
      <div className="reading-progress" ref={progress} aria-hidden="true" />
      <div className="nav-inner">
        <Link className="wordmark" to="/" aria-label="Fabulous J home">
          FJ<span>•</span>
        </Link>
        <span className="nav-caption">FABULOUS J / SOFTWARE ENGINEER</span>
        <nav
          id="main-navigation"
          className={`nav-links ${open ? "is-open" : ""}`}
          aria-label="Main navigation"
        >
          {navigation.map((label) => (
            <Link
              key={label}
              to={`/#${label.toLowerCase()}`}
              aria-current={
                active === label.toLowerCase() ? "location" : undefined
              }
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}
          <a className="resume-link" href="/Resume.pdf" download>
            Resume <span aria-hidden="true">↗</span>
          </a>
        </nav>
        <ThemeToggle />
        <button
          className="menu-toggle"
          ref={toggle}
          aria-expanded={open}
          aria-controls="main-navigation"
          onClick={() => {
            setOpen(!open);
            if (!open)
              requestAnimationFrame(() =>
                document
                  .querySelector<HTMLAnchorElement>("#main-navigation a")
                  ?.focus(),
              );
          }}
          type="button"
        >
          {open ? "Close −" : "Menu +"}
        </button>
      </div>
    </header>
  );
}
